import React, { Component } from "react";
import axios from "axios";
import "./App.css";

import Modal from "./Modal";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      htmlString:
        '<html><head><style>.test { padding: 24px; }</style><style>.wrapper { padding: 24px; }</style></head><body class="wrapper"><div class="app"></div></body></html>',
      newEmailBody: "",
      newEmailBodyMinified: "",
      modalStates: ["hidden", "loading", "show"],
      modalState: 0,
      accessibility: [],
    };

    this.postToPurge = this.postToPurge.bind(this);
    this.setHtml = this.setHtml.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.setState({ modalState: 0 });
  }

  setHtml(e) {
    this.setState({ htmlString: e.target.value });
  }

  postToPurge() {
    let cssArray = [];
    const doc = new DOMParser().parseFromString(
      this.state.htmlString,
      "text/html"
    );

    const matches = [...doc.querySelectorAll("style")];
    matches.forEach(function(node) {
      node.parentNode.removeChild(node);
      cssArray.push(node.textContent);
    });

    var s = new XMLSerializer();
    var styleRemovedHTML = s.serializeToString(doc);

    let css = cssArray.join("\n");

    this.setState({
      modalState: 1
    });

    axios({
      method: "post",
      url: "/",
      data: {
        html: styleRemovedHTML,
        css: css
      }
    }).then(response => {
      this.setState({
        newEmailBody: response.data.html,
        newEmailBodyMinified: response.data.minified,
        modalState: 2,
        accessibility: response.data.accessibility
      });
    });
  }

  render() {
    let modal =
      this.state.modalState !== 0 ? (
        <Modal
          a11y={this.state.accessibility}
          onCloseClick={this.closeModal}
          modalState={this.state.modalStates[this.state.modalState]}
          emailBody={this.state.newEmailBody}
          minBody={this.state.newEmailBodyMinified}
        />
      ) : null;

    return (
      <div className="App">
        <svg width="126" height="50" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" fillRule="evenodd">
            <path
              d="M95.18 3.643a3.477 3.477 0 0 1-3.515 3.515 3.476 3.476 0 0 1-3.512-3.515A3.476 3.476 0 0 1 91.665.13a3.477 3.477 0 0 1 3.514 3.514zm-73.03 19.79c0 5.055-3.406 8.582-8.28 8.582-4.874 0-8.277-3.527-8.277-8.581 0-5.052 3.403-8.579 8.277-8.579 4.874 0 8.28 3.527 8.28 8.579zM25.864.42h-1.99c-.868 0-1.575.706-1.575 1.575v11.212c-2.185-1.922-5.044-3.345-8.429-3.345C6.135 9.862.3 15.698.3 23.434c0 7.738 5.835 13.572 13.57 13.572 3.385 0 6.244-1.421 8.43-3.345v1.167c0 .868.706 1.575 1.574 1.575h1.99c.869 0 1.575-.707 1.575-1.575V1.995c0-.869-.706-1.575-1.575-1.575zm94.504 23.014c0 5.054-3.403 8.58-8.277 8.58-4.874 0-8.277-3.526-8.277-8.58 0-5.052 3.403-8.579 8.277-8.579 4.874 0 8.277 3.527 8.277 8.579zm-8.277-13.572c-7.735 0-13.57 5.836-13.57 13.572 0 7.738 5.835 13.572 13.57 13.572s13.57-5.834 13.57-13.572c0-7.736-5.835-13.572-13.57-13.572zm-17.854 2.413V34.8c0 .869-.709 1.575-1.577 1.575h-1.99a1.577 1.577 0 0 1-1.575-1.575V12.275c0-.869.706-1.575 1.575-1.575h1.99c.868 0 1.577.706 1.577 1.575zm-9.38 22.543c.283.372.356.767.2 1.084-.158.319-.515.5-.983.5h-3.297c-.77 0-1.727-.488-2.18-1.11l-6.768-9.319a.591.591 0 0 0-.423-.253.597.597 0 0 0-.456.188l-2.13 2.16c-.372.377-.7 1.174-.7 1.706v5.054c0 .868-.707 1.575-1.576 1.575h-1.99a1.577 1.577 0 0 1-1.575-1.575V1.995c0-.869.707-1.575 1.575-1.575h1.99c.869 0 1.575.706 1.575 1.575v19.051c0 .066.005.114.013.152a.81.81 0 0 0 .116-.099l9.574-9.462c.626-.593 1.535-.937 2.282-.937h3.747c.656 0 .884.309.962.496.076.185.137.565-.324 1.03L75.5 21.29c-.306.312-.342.866-.076 1.213l9.432 12.316zm-39.648-2.803c-4.874 0-8.277-3.527-8.277-8.581 0-5.052 3.403-8.579 8.277-8.579 4.875 0 8.278 3.527 8.278 8.579 0 5.054-3.403 8.58-8.278 8.58zm0-22.153c-7.735 0-13.569 5.836-13.569 13.572 0 7.738 5.834 13.572 13.57 13.572 7.735 0 13.569-5.834 13.569-13.572 0-7.736-5.834-13.572-13.57-13.572z"
              fill="#25373D"
            />
            <path
              d="M29.251 49.891c-9.277 0-16.6-4.894-16.906-5.102a1.307 1.307 0 0 1-.35-1.813 1.306 1.306 0 0 1 1.813-.347c.124.081 7.024 4.652 15.443 4.652 8.485 0 15.38-4.606 15.448-4.652a1.304 1.304 0 1 1 1.464 2.16c-.306.208-7.634 5.102-16.912 5.102"
              fill="#FFF"
            />
            <path
              d="M29.251 49.891c-9.277 0-16.6-4.894-16.906-5.102a1.307 1.307 0 0 1-.35-1.813 1.306 1.306 0 0 1 1.813-.347c.124.081 7.024 4.652 15.443 4.652 8.485 0 15.38-4.606 15.448-4.652a1.304 1.304 0 1 1 1.464 2.16c-.306.208-7.634 5.102-16.912 5.102"
              fill="#29C4BA"
            />
          </g>
        </svg>
        <h1>Email Optimiser Tool</h1>
        <p className='description'>This tool will scan your CSS and remove any unnecessary classes to help optimise file size and improve load time. To use, paste your entire email HTML code into the section below and hit the Optimise button.</p>
        <textarea
          rows="20"
          style={{ width: "80%" }}
          onChange={this.setHtml}
          value={this.state.htmlString}
        ></textarea>
        <button className="purge" onClick={this.postToPurge}>
          Optimise
        </button>
        {modal}
      </div>
    );
  }
}

export default App;
